import React, { useEffect, useState } from 'react';
import { UsersIcon } from 'lucide-react';
const TOTAL_SPOTS = 500;
export function ScarcityBar() {
  const [spotsLeft, setSpotsLeft] = useState(23);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(prev => prev <= 7 ? 23 : prev - 1);
    }, 22000);
    return () => window.clearInterval(id);
  }, []);
  const claimed = TOTAL_SPOTS - spotsLeft;
  const percent = Math.round(claimed / TOTAL_SPOTS * 100);
  return <div className="mx-auto w-full max-w-sm rounded-2xl border border-white/10 bg-navy-950/70 px-4 py-4" data-id="element-53" data-mp="2g5tm0a6qqmyl">
      <div className="flex items-baseline justify-between gap-3" data-id="element-54" data-mp="226bpt9r487f7">
        <p className="flex items-center gap-2 text-[0.72rem] font-bold uppercase tracking-[0.12em] text-slate-300" data-id="element-55" data-mp="2284z6wt455qw">
          <UsersIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-56" data-mp="276zp0iphzuki" />
          Spots at $27
        </p>
        <p className="font-display text-sm font-extrabold text-gold-500" data-id="element-57" data-mp="5ds50vyxwosa">
          {spotsLeft} left
        </p>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label={`${percent}% of launch spots claimed`} data-id="element-58" data-mp="33m39t4lfn5dc">
        <div className="h-full rounded-full bg-alert-500 transition-[width] duration-300 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-59" data-mp="38dlb5trdb7yu" />
      </div>
      <p className="mt-2 text-center text-[0.7rem] font-medium text-slate-400" data-id="element-60" data-mp="2koah0v4iwbto">
        {percent}% of the launch spots have already been claimed.
      </p>
    </div>;
}